import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];
  const mode = properties.mode || 'rules';

  if (mode === 'rules') {
    const rules = properties.rules?.values || [];

    if (rules.length === 0) {
      errors.push({
        key: 'rules',
        message: 'At least one rule is required',
      });
    }

    rules.forEach((rule: any, ruleIndex: number) => {
      const conditions = rule.conditions?.conditions || [];

      if (conditions.length === 0) {
        errors.push({
          key: `rules.values[${ruleIndex}].conditions`,
          message: 'At least one condition is required per rule',
        });
      }

      conditions.forEach((condition: any, condIndex: number) => {
        if (!condition.leftValue || condition.leftValue.trim() === '') {
          errors.push({
            key: `rules.values[${ruleIndex}].conditions.conditions[${condIndex}].leftValue`,
            message: 'Value 1 is required',
          });
        }

        // Check if rightValue is needed based on operator
        const noRightValueOperators = [
          'isEmpty', 'isNotEmpty', 'exists', 'notExists',
          'isTrue', 'isFalse', 'isNumber', 'isArray', 'isObject'
        ];

        if (!noRightValueOperators.includes(condition.operator)) {
          if (condition.rightValue === undefined || condition.rightValue === '') {
            errors.push({
              key: `rules.values[${ruleIndex}].conditions.conditions[${condIndex}].rightValue`,
              message: 'Value 2 is required for this operator',
            });
          }
        }
      });
    });
  } else if (mode === 'expression') {
    if (!properties.outputExpression || properties.outputExpression.trim() === '') {
      errors.push({
        key: 'outputExpression',
        message: 'Output expression is required',
      });
    }

    if (!properties.numberOfOutputs || properties.numberOfOutputs < 2) {
      errors.push({
        key: 'numberOfOutputs',
        message: 'At least 2 outputs are required',
      });
    }
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
